module.exports = __webpack_public_path__ + "img/settings-checked.c83e6795.svg";